import { render, staticRenderFns } from "./EditFare.vue?vue&type=template&id=44b5fcef&scoped=true&"
import script from "./EditFare.vue?vue&type=script&lang=js&"
export * from "./EditFare.vue?vue&type=script&lang=js&"
import style0 from "./EditFare.vue?vue&type=style&index=0&id=44b5fcef&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44b5fcef",
  null
  
)

export default component.exports